/* eslint-disable */
/// This file is auto generated - do not edit manually
export * as Drawer from './trans-website-regime-drawer';

export const RegimeDrawerButton = 'Website.Regime.RegimeDrawerButton';
